import * as React from 'react';
import RoomIcon from './RoomIcon';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { observer } from 'mobx-react';
import { Persona } from 'office-ui-fabric-react/lib/Persona';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { wrapWithLocationCard } from 'owa-location-card-v2';

const styles = require('./RoomPersona.scss');

export interface RoomPersonaProps {
    name: string;
    emailAddress: string;
    secondaryText: string;
    colorScheme: ColorScheme;
    className?: string;
}

/**
 * This is the room persona shown in the attendee list
 */
@observer
export default class RoomPersona extends React.Component<RoomPersonaProps, any> {
    render() {
        let { name, emailAddress, secondaryText, colorScheme, className } = this.props;
        let roomElement = (
            <Persona
                primaryText={name}
                size={PersonaSize.size32}
                secondaryText={secondaryText}
                showSecondaryText={secondaryText && secondaryText.length > 0}
                hidePersonaDetails={false}
                onRenderInitials={this.onRenderRoomIcon}
                className={className}
            />
        );

        return wrapWithLocationCard(
            name,
            null /* postalAddress */,
            emailAddress /* cardId */,
            roomElement,
            colorScheme,
            null /* onLocationCardUnmounted */,
            name /*locationAriaLabel*/,
            null /*phoneNumber*/,
            styles.hoverTarget
        );
    }

    private onRenderRoomIcon = (): JSX.Element => {
        return <RoomIcon backgroundColor={this.props.colorScheme.calPrimary} />;
    };
}
